/*
  MM: Piler (forrige/neste) på karusellene i høyre kolonne – kun desktop, kun malen product-test.
  «Ikke gå glipp av disse» (.mm-upsell__list) og «Inngår også i kits» (.mm-kits__list).
  Dra-med-mus/sveip/fremdriftslinje i assets/mm-upsell.js er uendret. Pilen blar ett kort om gangen.
*/
(() => {
  if (window.__mmPdpBox) return;
  window.__mmPdpBox = true;

  const mq = window.matchMedia('(min-width: 1000px)');
  const SELECTOR = '.product-info .mm-upsell__list, .product-info .mm-kits__list';
  const lang = (document.documentElement.lang || '').toLowerCase();
  const LABELS = lang.startsWith('sv')
    ? { prev: 'Föregående', next: 'Nästa' }
    : lang.startsWith('da')
      ? { prev: 'Forrige', next: 'Næste' }
      : { prev: 'Forrige', next: 'Neste' };

  const icon = (dir) =>
    `<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="${
      dir === 'next' ? 'M9 5l7 7-7 7' : 'M15 5l-7 7 7 7'
    }" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

  const stepSize = (list) => {
    const items = Array.from(list.children).filter((el) => el.offsetWidth > 0);
    if (items.length < 2) return list.clientWidth;
    return items[1].getBoundingClientRect().left - items[0].getBoundingClientRect().left;
  };

  const update = (state) => {
    const { list, host, prev, next } = state;
    if (!list.isConnected) return;
    const max = list.scrollWidth - list.clientWidth;
    const active = mq.matches && max > 2;
    prev.hidden = !active || list.scrollLeft <= 2;
    next.hidden = !active || list.scrollLeft >= max - 2;
    host.style.setProperty('--mm-arrow-top', `${list.offsetTop + list.offsetHeight / 2}px`);
  };

  const setup = (list) => {
    if (list._mmArrows) return;
    const host = list.parentElement;
    if (!host) return;
    host.classList.add('mm-arrows-host');

    const state = { list, host };
    const make = (dir) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `mm-carousel-arrow mm-carousel-arrow--${dir}`;
      button.setAttribute('aria-label', LABELS[dir]);
      button.innerHTML = icon(dir);
      button.hidden = true;
      button.addEventListener('click', () => {
        list.scrollBy({ left: stepSize(list) * (dir === 'next' ? 1 : -1), behavior: 'smooth' });
      });
      host.appendChild(button);
      return button;
    };
    state.prev = make('prev');
    state.next = make('next');
    list._mmArrows = state;

    let frame = 0;
    const schedule = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => update(state));
    };
    list.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    if (mq.addEventListener) mq.addEventListener('change', schedule);
    if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(list);
    schedule();
  };

  const scan = () => document.querySelectorAll(SELECTOR).forEach(setup);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }

  /* Variantbytte kan rendre produktinfo på nytt – sett opp pilene igjen ved behov */
  let timer = 0;
  const root = document.querySelector('.shopify-section--main-product') || document.body;
  new MutationObserver(() => {
    clearTimeout(timer);
    timer = setTimeout(scan, 120);
  }).observe(root, { childList: true, subtree: true });
})();

/*
  MM: Merker bildet som vises i produktgalleriet med klassen «mm-is-current» (malen product-test).
  Brukes av assets/mm-pdp-mobile-gallery.css (rette venstre hjørner på bildet som vises på mobil).
  Lytter bare på galleriets egne signaler (carousel:change/settle/select); galleriets JS er uendret.
*/
(() => {
  if (window.__mmGalleryCurrent) return;
  window.__mmGalleryCurrent = true;

  const SELECTOR = '.shopify-section--main-product product-gallery-swiper';

  const mark = (swiper, cell) => {
    const cells = swiper.querySelectorAll('.product-gallery__media');
    const current = cell || swiper.selectedCell || swiper.querySelector('.product-gallery__media.is-initial') || cells[0];
    cells.forEach((el) => el.classList.toggle('mm-is-current', el === current));
  };

  const setup = (swiper) => {
    if (swiper._mmCurrent) return;
    swiper._mmCurrent = true;
    ['carousel:change', 'carousel:settle', 'carousel:select'].forEach((name) =>
      swiper.addEventListener(name, (event) => mark(swiper, event.detail && event.detail.cell))
    );
    mark(swiper);
  };

  const scan = () => document.querySelectorAll(SELECTOR).forEach(setup);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }
  document.addEventListener('product:rerender', () => setTimeout(scan, 50));
  window.addEventListener('load', scan, { once: true });
})();

/*
  MM: Fremdriftslinje under slideren «Hva andre kjøper (ved omtaler)» på desktop (kun malen product-test).
  Viser bare hvor langt slideren er bladd – pilene/blaing er temaets egne og uendret.
  Stil i assets/mm-pdp-lipscore.css (.mm-hr-progress). Hello Retail fyller seksjonen senere, derfor MutationObserver.
*/
(() => {
  if (window.__mmHrProgress) return;
  window.__mmHrProgress = true;

  const SECTION = '.shopify-section[id*="__related_products_omtaler"]';

  const setup = (scroller) => {
    if (scroller._mmProgress) return;
    const host = scroller.closest('.floating-controls-container') || scroller;
    const bar = document.createElement('div');
    bar.className = 'mm-hr-progress';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<span class="mm-hr-progress__fill"></span>';
    host.after(bar);
    const fill = bar.firstElementChild;
    scroller._mmProgress = bar;

    let frame = 0;
    const update = () => {
      const max = scroller.scrollWidth - scroller.clientWidth;
      const visible = scroller.scrollWidth > 0 ? scroller.clientWidth / scroller.scrollWidth : 1;
      bar.hidden = max <= 2;
      const w = Math.max(0.12, Math.min(1, visible));
      const pos = max > 0 ? Math.abs(scroller.scrollLeft) / max : 0;
      fill.style.width = (w * 100) + '%';
      fill.style.transform = 'translateX(' + (pos * (1 - w) / w * 100) + '%)';
    };
    const schedule = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); };
    scroller.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(scroller);
    schedule();
  };

  const scan = () => document.querySelectorAll(SECTION + ' scroll-carousel, ' + SECTION + ' .product-list--carousel').forEach((el) => {
    const scroller = el.matches('scroll-carousel') ? el : el.closest('scroll-carousel') || el;
    setup(scroller);
  });

  const start = () => {
    scan();
    const root = document.querySelector(SECTION);
    if (!root) return;
    let t = 0;
    new MutationObserver((records) => {
      if (records.some((r) => !(r.target.closest && r.target.closest('.mm-hr-progress')))) { clearTimeout(t); t = setTimeout(scan, 80); }
    }).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

/*
  MM: Før/etter-slider i produktgalleriet (malene product-test og foundations).
  Bilde med alt-tekst som starter med «[før]» (eller [before]) + neste bilde med «[etter]» (eller [after])
  vises som ett bilde med dra-strek. Etter-bildet skjules som eget bilde (også etter fargebytte).
  Produkter uten slike bilder påvirkes ikke. Temaets gallerifiler røres ikke.
*/
(() => {
  const isTag = (alt, tags) => { const a = (alt || '').trim().toLowerCase(); return tags.some((t) => a.startsWith(t)); };
  const BEFORE = ['[før]', '[for]', '[before]', '[före]'];
  const AFTER = ['[etter]', '[after]', '[efter]'];
  const lang = (document.documentElement.lang || '').toLowerCase();
  const country = ((window.Shopify && window.Shopify.country) || '').toUpperCase();
  /* Danmark ligger i SE-butikken og kan ha svensk språkkode – landet avgjør da dansk tekst */
  const da = lang.startsWith('da') || country === 'DK';
  const sv = !da && lang.startsWith('sv');
  const LBL_BEFORE = sv ? 'Före' : 'Før';
  const LBL_AFTER = sv || da ? 'Efter' : 'Etter';
  const MIN = 3, MAX = 97;

  const imgOf = (cell) => cell.querySelector('img');

  const keepHidden = (el) => {
    if (!el || el.dataset.mmBaHidden) return;
    el.dataset.mmBaHidden = '1';
    el.hidden = true;
    new MutationObserver(() => { if (!el.hidden) el.hidden = true; }).observe(el, { attributes: true, attributeFilter: ['hidden'] });
  };

  const build = (swiper, beforeCell, afterCell) => {
    if (beforeCell.dataset.mmBa) return;
    beforeCell.dataset.mmBa = '1';
    const beforeImg = imgOf(beforeCell);
    const afterImg = imgOf(afterCell);
    if (!beforeImg || !afterImg) return;

    // 1) Skjul etter-bildet som eget bilde: galleriets filter får alltid med indeksen til etter-bildet
    const all = swiper.allCells;
    const afterIndex = all.indexOf(afterCell);
    if (typeof swiper.filter === 'function' && !swiper.__mmBaWrapped) {
      const orig = swiper.filter.bind(swiper);
      swiper.__mmBaExtra = new Set();
      swiper.filter = (indexes = []) => orig(Array.from(new Set([...(indexes || []), ...swiper.__mmBaExtra])));
      swiper.__mmBaWrapped = true;
    }
    if (swiper.__mmBaExtra) swiper.__mmBaExtra.add(afterIndex);
    const currentHidden = swiper.allCells.map((c, i) => (c.hasAttribute('hidden') ? i : -1)).filter((i) => i >= 0);
    if (typeof swiper.filter === 'function') swiper.filter(currentHidden); else keepHidden(afterCell);
    keepHidden(afterCell);
    const gallery = swiper.closest('.product-gallery') || document;
    const afterId = afterCell.dataset.mediaId;
    if (afterId) gallery.querySelectorAll('.product-gallery__thumbnail[data-media-id="' + afterId + '"]').forEach(keepHidden);
    const segs = gallery.querySelectorAll('.product-gallery__carousel-navigation-segment');
    if (segs.length === all.length && segs[afterIndex]) keepHidden(segs[afterIndex]);

    // 2) Bygg slideren i før-bildets ramme
    beforeCell.classList.add('mm-ba');
    const layer = document.createElement('div');
    layer.className = 'mm-ba__after';
    layer.setAttribute('aria-hidden', 'true');
    const clone = afterImg.cloneNode(true);
    clone.removeAttribute('fetchpriority');
    clone.loading = 'eager';
    clone.className = 'mm-ba__after-img';
    layer.appendChild(clone);

    const line = document.createElement('div');
    line.className = 'mm-ba__line';
    line.setAttribute('role', 'slider');
    line.setAttribute('tabindex', '0');
    line.setAttribute('aria-label', LBL_BEFORE + ' / ' + LBL_AFTER);
    line.setAttribute('aria-valuemin', String(MIN));
    line.setAttribute('aria-valuemax', String(MAX));
    line.innerHTML = '<span class="mm-ba__knob" aria-hidden="true"><svg viewBox="0 0 24 24" focusable="false"><path d="M9.5 7.5 5 12l4.5 4.5M14.5 7.5 19 12l-4.5 4.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';

    const lb = document.createElement('span'); lb.className = 'mm-ba__label mm-ba__label--before'; lb.textContent = LBL_BEFORE; lb.setAttribute('aria-hidden', 'true');
    const la = document.createElement('span'); la.className = 'mm-ba__label mm-ba__label--after'; la.textContent = LBL_AFTER; la.setAttribute('aria-hidden', 'true');

    const frame = document.createElement('div');
    frame.className = 'mm-ba__frame';
    frame.append(layer, line, lb, la);
    beforeCell.appendChild(frame);

    // Rammen legges nøyaktig over før-bildet (samme utsnitt/format som galleriet viser)
    const place = () => {
      const c = beforeCell.getBoundingClientRect();
      const r = beforeImg.getBoundingClientRect();
      if (!r.width || !c.width) return;
      frame.style.left = (r.left - c.left) + 'px';
      frame.style.top = (r.top - c.top) + 'px';
      frame.style.width = r.width + 'px';
      frame.style.height = r.height + 'px';
      const cs = getComputedStyle(beforeImg);
      clone.style.objectFit = cs.objectFit;
      clone.style.objectPosition = cs.objectPosition;
    };
    if ('ResizeObserver' in window) new ResizeObserver(place).observe(beforeImg);
    window.addEventListener('resize', place);
    if (!beforeImg.complete) beforeImg.addEventListener('load', place, { once: true });
    place();

    let pos = 50;
    const set = (p) => {
      pos = Math.min(MAX, Math.max(MIN, p));
      frame.style.setProperty('--mm-ba-pos', pos + '%');
      line.setAttribute('aria-valuenow', String(Math.round(pos)));
      lb.classList.toggle('is-hidden', pos < 14);
      la.classList.toggle('is-hidden', pos > 86);
    };
    set(50);

    // 3) Dra: kun på streken/håndtaket – stopper galleriets sveip og zoom
    const fromX = (x) => { const r = frame.getBoundingClientRect(); return ((x - r.left) / r.width) * 100; };
    const stop = (e) => { e.stopPropagation(); };
    ['touchstart', 'touchmove', 'mousedown', 'click', 'dblclick'].forEach((t) => line.addEventListener(t, stop, { passive: t !== 'touchmove' ? true : false }));
    line.addEventListener('touchmove', (e) => { e.preventDefault(); }, { passive: false });
    let dragging = false;
    line.addEventListener('pointerdown', (e) => {
      dragging = true;
      e.stopPropagation();
      e.preventDefault();
      try { line.setPointerCapture(e.pointerId); } catch (_) {}
      line.classList.add('is-dragging');
    });
    line.addEventListener('pointermove', (e) => { if (dragging) { e.stopPropagation(); set(fromX(e.clientX)); } });
    const end = (e) => { if (!dragging) return; dragging = false; line.classList.remove('is-dragging'); try { line.releasePointerCapture(e.pointerId); } catch (_) {} };
    line.addEventListener('pointerup', end);
    line.addEventListener('pointercancel', end);
    line.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { set(pos - 5); e.preventDefault(); e.stopPropagation(); }
      else if (e.key === 'ArrowRight') { set(pos + 5); e.preventDefault(); e.stopPropagation(); }
      else if (e.key === 'Home') { set(MIN); e.preventDefault(); }
      else if (e.key === 'End') { set(MAX); e.preventDefault(); }
    });
    // Klikk på selve rammen (ikke streken) skal ikke åpne zoom
    frame.addEventListener('click', stop);
  };

  const scan = (swiper) => {
    const cells = swiper.allCells || Array.from(swiper.querySelectorAll('.product-gallery__media'));
    for (let i = 0; i < cells.length - 1; i++) {
      const b = imgOf(cells[i]);
      if (!b || !isTag(b.alt, BEFORE)) continue;
      const a = imgOf(cells[i + 1]);
      if (a && isTag(a.alt, AFTER)) { build(swiper, cells[i], cells[i + 1]); i++; }
    }
  };

  const start = () => {
    const swipers = document.querySelectorAll('product-gallery-swiper');
    if (!swipers.length) return;
    const go = () => swipers.forEach((s) => { try { scan(s); } catch (err) { if (window.console) console.warn('MM før/etter:', err); } });
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('product-gallery-swiper').then(() => requestAnimationFrame(go));
    } else {
      go();
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

/*
  MM: Flytter Beauty Club-boksen (#discount, Modish) inn i seksjonen «MM Beauty Club» når den finnes i malen.
  Uten seksjonen skjer ingenting.
*/
(() => {
  const move = () => {
    const slot = document.querySelector('[data-mm-discount-slot]');
    const box = document.getElementById('discount');
    if (!slot || !box || slot.contains(box)) return;
    box.classList.remove('product-content-below-gallery');
    slot.appendChild(box);
    document.documentElement.classList.add('mm-beauty-club-moved');
    tidy(slot);
    new MutationObserver(() => tidy(slot)).observe(slot, { childList: true, subtree: true });
  };

  /* Fjerner appens tvingende layout-stiler (avstander, bredder, rammer, skrift) i seksjonen.
     Farger fra Beauty Club-dashboardet beholdes. Overskriften flyttes over den grå boksen. */
  const LAYOUT = ['padding', 'margin', 'margin-top', 'margin-left', 'max-width', 'width', 'font-weight', 'font-size',
    'border', 'border-width', 'border-radius', 'display', 'justify-content', 'text-align'];
  const tidy = (slot) => {
    const form = slot.querySelector('#loyaltyForm');
    if (!form || form.dataset.mmTidy) return;
    form.dataset.mmTidy = '1';
    form.querySelectorAll('[style]').forEach((el) => LAYOUT.forEach((p) => el.style.removeProperty(p)));
    const benefits = form.querySelector('.single-product-discount-sign-up-benefit-wrapper');
    if (benefits) {
      benefits.style.removeProperty('background');
      benefits.style.removeProperty('border');
      /* Tekst limt inn med formatering (f.eks. hvit bakgrunn bak linjene) – fjern bakgrunnsfarge på teksten */
      benefits.querySelectorAll('*').forEach((el) => {
        el.style.removeProperty('background');
        el.style.removeProperty('background-color');
        el.removeAttribute('bgcolor');
      });
    }
    const title = form.querySelector('.single-product-discount-title');
    if (title) { title.classList.add('mm-beauty-club__heading'); form.parentNode.insertBefore(title, form); }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', move, { once: true });
  else move();
})();
